import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=0ed8601d&scoped=true&"
var script = {}
import style0 from "./triangle.vue?vue&type=style&index=0&id=0ed8601d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8601d",
  null
  
)

export default component.exports